import * as React from "react";
const SvgNonSelectedCycle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 10, fill: "#000", fillOpacity: 0.1 }));
export default SvgNonSelectedCycle;
